import React from 'react';
import MuiSnackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
export const Snackbar = ({ open, autoHideDuration, onClose, title, variant, anchorOrigin, _sx = {}, className = '', dataTestId, }) => {
    return (React.createElement(MuiSnackbar, { open: open, autoHideDuration: autoHideDuration, onClose: onClose, anchorOrigin: anchorOrigin, sx: _sx, className: className, "data-testid": dataTestId },
        React.createElement(Alert, { onClose: onClose, severity: variant }, title)));
};
